export default "__VITE_ASSET__DFn1VGO1__"